module.exports = __webpack_public_path__ + "img/icon5.3e9436d3.png";